import { MessageCircle } from "lucide-react";

const WhatsAppButton = ({ phone }) => {
  if (!phone) return null;

  const handleClick = () => {
    const cleanPhone = phone.replace(/[^0-9]/g, "");
    window.open(`https://wa.me/${cleanPhone}`, "_blank");
  };

  return (
    <button
      onClick={handleClick}
      className="whatsapp-float"
      aria-label="Contact via WhatsApp"
      data-testid="whatsapp-float-btn"
    >
      <MessageCircle className="h-6 w-6 text-white" />
    </button>
  );
};

export default WhatsAppButton;
